module.exports = __webpack_public_path__ + "img/Group_27920.af270310.png";